import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { buildMasterdataHelper } from "../factory";
export const MasterSystemProductFragment = gql `
  fragment _ on Product {
    id
    isSystemProduct
    isYearly
    name
    buyInQuantities
    buyOneAtATime
    codename
    description
    orderNo
    priceCents
    priceCurrency
    rank
    relatedEntities
    showInPriceList
    status
    activatedAt
    disabledAt
    updatedAt
    createdAt
    nameTranslations {
      locale
      value
    }
    descriptionTranslations {
      locale
      value
    }
  }
`;
export function useSystemProductHelper() {
    function getProducts() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query MasterSystemProducts {
            systemProducts {
              ${MasterSystemProductFragment}
            }
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.systemProducts) !== null && _b !== void 0 ? _b : []);
    }
    const { masterdataEntities, activeEntities, addMissingSelectValue } = buildMasterdataHelper(getProducts);
    function getSystemProductFromMaster(codename, options = { key: null, isId: false }) {
        if (options.isId) {
            const product = masterdataEntities.value.find(product => product.id == codename);
            if (options.key && product)
                return product[options.key];
            else
                return product;
        }
        else {
            const product = masterdataEntities.value.find(product => product.codename == codename);
            if (options.key && product)
                return product[options.key];
            else
                return product;
        }
    }
    function systemProductIsActive(codename) {
        return (getSystemProductFromMaster(codename, { key: "status", isId: false }) ==
            "active");
    }
    return {
        masterProducts: masterdataEntities,
        activeMasterSystemProducts: activeEntities,
        getSystemProductFromMaster,
        withMissingSystemProductselect: addMissingSelectValue,
        systemProductIsActive
    };
}
